<template>
    <div class="page" v-if="washImages">
        <div class="comp-title">
            <span>照片详情</span>
            <el-button icon="el-icon-close" circle @click="close"></el-button>
        </div>
        <div class="content">
            <div class="image-box">
                <el-image
                    v-for="(item,index) in imageList"
                    :key="index"
                    @click='updateSrcList(item)'
                    style='width: 200px; height: 150px; margin-top: 10px; margin-left: 10px'
                    :src='item'
                    :preview-src-list='srcList'
                ></el-image>
            </div>
        </div>
    </div>
</template>

<script>
import { get, post, put } from '@/utils/request.js';
export default {
    data(){
        return{
            washImages: false,
            imageList: [],
            srcList: [''],
        }
    },
    methods:{
        // 打开
        show(pics){
            this.imageList = pics.split('|')
            this.washImages = true;
        },

        // 关闭
        close(){
            this.imageList = []
            this.washImages = false;
        },

        // 更新
        updateSrcList(src) {
            this.srcList[0] = src;
        },

    }
}
</script>

<style scoped lang="scss">
.page {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    background-color: #ccc;

    .comp-title {
        width: 100%;
        height: 60px;
        padding: 10px;
        border-bottom: 1px solid #ccc;
        background-color: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .content {
        padding: 5px;

        .image-box{
            display: flex;
            flex-wrap: wrap;
            flex-direction: row;

            img{
                width: 200px;
                height: 150px;
                margin-left: 10px;
                margin-top: 10px;
            }
        }
    }
}
</style>